import React, { useEffect, useState } from 'react';
import { useTheme, Grid, Stack, Dialog, DialogContent, Typography, TextField, IconButton, SvgIcon } from '@mui/material';
import {tokens} from '../theme';
import CustomButton from './CustomButton';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, {  } from 'dayjs';
import { StaticDatePicker } from '@mui/x-date-pickers';

export const IncentivesActionsConfirmationDialog = ({ open, handleClose, handleSubmit, type ,title }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  const today = dayjs();
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedFile, setSelectedFile] = useState(null);
  const [comment, setComment] = useState('');

  const [datePickerVisibility, setDatePickerVisibility] = useState(false);
  const [uploadFileVisibility, setUploadFileVisibility] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const type = file.type.split("/")[1];
    if (file) {
      if(file.type!=="application/pdf" && file.type!=="image/jpg" && file.type!=="image/jpeg" && file.type!=="image/png"){
        alert(type+" is not allowed to upload, please choose only Image or PDF file.")
        setSelectedFile(null);
      }else{
        setSelectedFile(file);
      }

    }
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const onSubmit = () => {
    if(comment === null || comment===''){
        alert("Comment field is mandatory!")
    }else{
        const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD')
        handleSubmit(selectedFile, comment, type, formattedDate);
        setSelectedFile(null);
        setComment('');
        handleClose();
    }
   
  };

  useEffect(() => {
    switch(type){
      case "Approve":
        setDatePickerVisibility(true);
        setUploadFileVisibility(true);
        break;

      case "Hold":
        setDatePickerVisibility(false);
        setUploadFileVisibility(true);
        break;

        case "Cancel":
        setDatePickerVisibility(false);
        setUploadFileVisibility(true);
        break;

        case "Release":
        setDatePickerVisibility(true);
        setUploadFileVisibility(true);
        break;

        case "Request Release":
          setDatePickerVisibility(true);
          setUploadFileVisibility(true);
          break;

        

      default:
        setDatePickerVisibility(false);
        setUploadFileVisibility(true);
        break;
    }
  },[type]);

  return (
    <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { borderRadius: "12px", background:"transparent", boxShadow:"none" } }} >
      
      <DialogContent sx={{ background:"white", borderRadius:"12px", overflow: "initial", marginBottom:"15px" }}>
        <Grid container direction={'column'} alignItems={"center"} alignContent={"center"} justifyItems={"center"} justifyContent={"center"}   >
          
          <Grid container xs={10}>

            <Grid container justifyContent={"center"}>
              <Typography fontWeight={'600'} variant="h3" p={1}>{title}</Typography>
            </Grid>

            <Grid container>

              {/*** Date Picker ***/}
              {datePickerVisibility &&
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <StaticDatePicker
                      //defaultValue={setTodaysDate}
                      label="Choose Date"
                      value={selectedDate}
                      onChange={(newValue) => setSelectedDate(newValue)}
                      //maxDate={today}
                      minDate={today}
                      orientation="landscape"
                      ToolbarComponent={() => <></>} // Hides the toolbar, including the 'Cancel' and 'OK' buttons
                      sx={{
                        marginTop: '3px',
                        '& .MuiDialogActions-root': { // Targets the actions bar containing 'Cancel' and 'OK' buttons
                          display: 'none',
                        },
                      }}
                    />
                  </LocalizationProvider>
              } 


              <Grid
                container
                justifyContent={"flex-start"}
                mt={3}
                pb={2}
              >


                {/**** Attach File ***/}
                {uploadFileVisibility &&
                  <>
                    <input
                    accept="*"
                    style={{ display: 'none' }}
                    id="file-upload"
                    type="file"
                    variant="outlined"
                    label="Optional"
                    onChange={handleFileChange}
                    />

                    <label>Attachment (Optional)</label>

                    <label htmlFor="file-upload" style={{
                      border:"1px solid #94B0E0", 
                      borderRadius:"64px",
                      width:"100%", 
                      textAlign:"center",
                      margin:"15px auto",
                      fontSize: "12px",
                      fontWeight: "700",
                      letterSpacing: "1.25px",
                      padding: "6px 24px",
                      textTransform : "uppercase",
                      cursor:"pointer"
                      }} >
                      <IconButton color="primary" component="span">
                        <SvgIcon sx={{ width:"32px", height:"auto" }}>
                        <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M26.7987 31.8646C28.9204 31.8804 30.9629 31.0887 32.5304 29.6637C37.7079 25.1354 34.9371 16.0471 28.1129 15.1921C25.6746 0.40375 4.34708 6.00875 9.39791 20.0846" stroke="#292D32" stroke-width="2.375" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12.0263 20.7317C11.1872 20.3042 10.253 20.0825 9.31883 20.0983C1.9405 20.6208 1.95633 31.3558 9.31883 31.8783" stroke="#292D32" stroke-width="2.375" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M25.5488 15.8542C26.3722 15.4426 27.2588 15.2209 28.1772 15.2051" stroke="#292D32" stroke-width="2.375" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M17.8691 35.0293V25.5293" stroke="#292D32" stroke-width="2.375" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M13.6738 29.485L17.7272 25.4316L21.7805 29.485" stroke="#292D32" stroke-width="2.375" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </SvgIcon>
                      </IconButton>
                      {selectedFile ? selectedFile.name : "Upload Attachment"}
                    </label>
                  </>
                }

                {/*** Comment ***/}
                <TextField
                  margin="dense"
                  label="Comment"
                  type="text"
                  fullWidth
                  variant="standard"
                  value={comment}
                  onChange={handleCommentChange}
                />

                <Grid container justifyContent={"flex-end"}>
                  <Stack
                    direction="row"
                    pt={2}
                    spacing={2}
                    justifyContent={'center'}
                  >
                    <CustomButton
                      btnBG={colors.primary[900]}
                      btnColor={colors.grey[100]}
                      btnTxt={'Cancel'}
                      btnBorder={'1px solid' + colors.primary[800]}
                      onClick={handleClose}
                    ></CustomButton>

                    <CustomButton
                      btnBG={colors.primary[100]}
                      btnColor={colors.grey[900]}
                      btnTxt={'Submit'}
                      btnBorder={'1px solid' + colors.primary[100]}
                      onClick={onSubmit}
                    ></CustomButton>

  {/* 
                    <Button onClick={} color="secondary">
                    Cancel
                  </Button>
                  <Button onClick={onSubmit} color="primary">
                    Submit
                  </Button> */}
                  </Stack>
                </Grid>

            </Grid>

          </Grid>

            
        
          </Grid>

        </Grid>
        
      </DialogContent>

      {/* <DialogActions> */}
        
      {/* </DialogActions> */}
    </Dialog>



    // <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { borderRadius: "12px", background:"transparent", boxShadow:"none" } }}>
    //   <DialogTitle>{title}</DialogTitle>
    //   <DialogContent>
        
        // {/**** Attach File ***/}
        // {uploadFileVisibility &&
    //       <>  
    //         <input
    //           accept="*"
    //           style={{ display: 'none' }}
    //           id="file-upload"
    //           type="file"
    //           variant="outlined"
    //           label="Optional"
    //           onChange={handleFileChange}
    //         />
    //         <label htmlFor="file-upload">
    //           <IconButton color="primary" component="span">
    //             <AttachFileIcon />
    //           </IconButton>
    //           {selectedFile ? selectedFile.name : "No file selected"}
    //         </label>
    //       </>
    //     }

    //     {/*** Comment ***/}
    //     <TextField
    //       margin="dense"
    //       label="Comment"
    //       type="text"
    //       fullWidth
    //       variant="standard"
    //       value={comment}
    //       onChange={handleCommentChange}
    //     />
    //   </DialogContent>
    //   <DialogActions>
    //     <Button onClick={handleClose} color="secondary">
    //       Cancel
    //     </Button>
    //     <Button onClick={onSubmit} color="primary">
    //       Submit
    //     </Button>
    //   </DialogActions>
    // </Dialog>
  );
};
